<template>
  <div class="login">
    <v-container>
      <div style="margin-bottom: 10px; margin-top:10px;">
        <v-row align="center" justify="center">
          <v-col align-self="center" cols="auto">
            <v-img
              src="../../assets/img/logo_pfo.png"
              max-width="170px"
              width="100%"
            ></v-img>
          </v-col>
        </v-row>
      </div>

      <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
        <v-row align="center" justify="center">
          <v-col align-self="center" cols="auto" style="text-align: center">
            <v-card class="pa-4" max-width="450">
              <form
                :key="1"
                v-if="me.password_reset"
                @submit.prevent="handleSubmit(submitReset)"
              >
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <span class="text-h5">
                        Insira sua nova senha nos campos abaixo.
                      </span>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <BaseInputValidation
                        id="password"
                        dense
                        type="password"
                        name="Nova Senha"
                        rules="required|strongPassword"
                        vid="password"
                        data-vv-name="password"
                        v-model="form.password"
                      ></BaseInputValidation>
                    </v-col>
                    <v-col class="pt-0 pb-0">
                      <BaseInputValidation
                        id="password_confirm"
                        dense
                        type="password"
                        name="Confirmar Senha"
                        rules="required|confirmed:password"
                        data-vv-as="password"
                        v-model="form.password_confirm"
                      ></BaseInputValidation>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <v-btn
                        :disabled="invalid"
                        block
                        id="next"
                        style="color: white"
                        rounded
                        x-large
                        color="#0894C0"
                        class="mr-4"
                        type="submit"
                      >
                        CONFIRMAR
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </form>
              <form
                v-else-if="recoveryPassword"
                :key="2"
                @submit.prevent="handleSubmit(submitRecovery)"
              >
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <span class="text-h5">
                        Uma nova senha será gerada e enviada ao seu email de
                        cadastro.
                      </span>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <span>
                        <BaseInputValidation
                          id="email"
                          dense
                          name="E-mail"
                          rules="required|email"
                          v-model="form.email"
                        ></BaseInputValidation>
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col class="pt-0">
                      <v-btn
                        block
                        x-large
                        rounded
                        id="next"
                        class="mr-4"
                        @click="recoveryPassword = false"
                      >
                        VOLTAR
                      </v-btn>
                    </v-col>
                    <v-col class="pt-0">
                      <v-btn
                        block
                        x-large
                        rounded
                        id="next"
                        style="color: white"
                        color="#0894C0"
                        class="mr-4"
                        type="submit"
                        :disabled="invalid"
                      >
                        ENVIAR
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </form>
              <form v-else :key="3" @submit.prevent="handleSubmit(submit)">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <span class="text-h5">
                        Insira seus dados de acesso nos campos abaixo.
                      </span>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <span>
                        <BaseInputValidation
                          id="email"
                          dense
                          name="E-mail"
                          rules="required|email"
                          v-model="form.email"
                        ></BaseInputValidation>
                      </span>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-0">
                      <BaseInputValidation
                        type="password"
                        id="password"
                        dense
                        name="Senha"
                        rules="required"
                        v-model="form.password"
                      ></BaseInputValidation>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col class="pt-0">
                      <v-btn
                        :disabled="invalid"
                        block
                        id="next"
                        style="color: white"
                        rounded
                        x-large
                        color="#0894C0"
                        class="mr-4"
                        type="submit"
                      >
                        ENTRAR
                      </v-btn>
                    </v-col>
                    <v-col class="pt-0" v-if="false">
                      <v-btn
                        :to="{ name: 'register', query: { passo: 1 } }"
                        block
                        id="next"
                        style="color: white"
                        rounded
                        x-large
                        color="#0894C0"
                        class="mr-4"
                      >
                        CADASTRE-SE
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        id="next"
                        block
                        text
                        x-small
                        color="#444444"
                        class="mr-4"
                        @click="recoveryPassword = true"
                      >
                        recuperar senha
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </form>
            </v-card>
          </v-col>
        </v-row>
      </validation-observer>
      <div>
        <v-row align="center" justify="center">
          <v-icon size="140px" color="white">icon-logo_sebrae_ba</v-icon>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { ValidationObserver, setInteractionMode } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import store from "./_store";
import { mask } from "vue-the-mask";

setInteractionMode("eager");
import BaseInputValidation from "../../components/UI/BaseInputValidation";
export default {
  directives: { mask },
  data: () => ({
    form: {
      email: ""
    },

    recoveryPassword: false
  }),
  computed: {
    ...mapGetters({
      me: "$_auth/me"
    })
  },
  components: {
    BaseInputValidation,
    ValidationObserver
  },

  methods: {
    ...mapActions({
      login: "$_auth/login",
      passwordReset: "$_auth/passwordReset",
      passwordRecovery: "$_auth/passwordRecovery",
      message: "$_messages/setErrors"
    }),
    async submit() {
      await this.login(this.form);
      await this.message({
        message: `Logado como ${this.me.name ??
          this.me.providers[0].trade_name}.`,
        type: "success",
        title: "error!",
        timeout: 4000
      });

      this.form = {};

      if (!this.me.password_reset) this.$router.push("/");
    },
    async submitReset() {
      await this.passwordReset(this.form);
      await this.message({
        message: `Senha alterada com sucesso.`,
        type: "success",
        title: "Sucesso",
        timeout: 4000
      });
      await this.$store.dispatch(
        `$_communication/getCommunicationsNotification`,
        { limit: -1 }
      );
      this.$router.push("/");
    },
    async submitRecovery() {
      await this.passwordRecovery(this.form);
      await this.message({
        message: `Um email com a senha provisória foi enviado para a sua caixa de entrada.`,
        type: "success",
        title: "Sucesso",
        timeout: 4000
      });
      this.recoveryPassword = false;
      (this.form.email = ""), (this.form.employee_number = "");
      this.form.password = "";
    }
  },

  beforeCreate() {
    const STORE_AUTH = "$_auth";
    if (!(STORE_AUTH in this.$store._modules.root._children))
      this.$store.registerModule(STORE_AUTH, store);
  }
};
</script>

<style lang="scss" scoped>
.login {
  background-color: #00afef !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
</style>
